import { useQueryStates } from 'nuqs';
import { useEffect } from 'react';
import { SEARCH_PARAMS } from '@/routes/search-params';
import { getStoredActiveTab } from '@/sections/StatusQuoAnalysis/contexts/activeTabStorage';

// An explicit `?tab=` in the URL (e.g. a shared link) always wins over the stored value.
export function useRestoreLastActiveTab(storageKey: string | undefined) {
  const [, setQueryParams] = useQueryStates(SEARCH_PARAMS.statusQuoAnalysis.building);

  useEffect(() => {
    if (!storageKey || new URLSearchParams(window.location.search).has('tab')) return;

    const storedTab = getStoredActiveTab(storageKey);
    if (storedTab) {
      void setQueryParams({ tab: storedTab }, { history: 'replace' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
